import { UserRolesType } from '../../components/LoginForm/types';
import { useAppSelector } from '../../reducers/rootReducer';
import { userDetailsSelectors } from '../../reducers/userDetailsSlice';

const useUserRole = (role: UserRolesType) => {
  const userRoles = useAppSelector(userDetailsSelectors.selectCurrentUserRoles);
  return userRoles?.includes(role);
};

export default useUserRole;
